import { Box, Typography } from "@mui/material";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        position: "fixed",
        bottom: 0,
        left: 0,
        py: 1.5,
        textAlign: "center",
        backgroundColor: "#dec328",
        zIndex: 1200,
        boxShadow: "0 -2px 10px rgba(0,0,0,0.15)",
      }}
    >
      <Typography
        sx={{
          fontSize: "14px",
          color: "#0c3c60",
          fontWeight: 500,
          letterSpacing: "0.3px",
        }}
      >
        © {year} | LegalStream, Inc. - A NCB Management Services, Inc. Company
      </Typography>
    </Box>
  );
};

export default Footer;
